<template>
  <div class="Zoom">

    <transition name="scale" appear>
      <div class="Zoom_wrapper">
        <img class="Zoom_background mobile" ref="background" src="/assets/images/zoom-mobile.jpg" data-zoom-value="2"></img>
        <img class="Zoom_background desktop" ref="background" src="/assets/images/zoom.jpg" data-zoom-value="2"></img>
      </div>
    </transition>
    <div class="Zoom_mask"></div>

    <div class="Close" @click="close"><img class="Shape_optim" src="/assets/images/shape-small.svg" /><i class="fad fa-times-circle"></i></div>
    <button class="Cta" @click="close">Fermer</button>
  </div>
</template>

<script>

  export default {
    props: [  ],
    data() {
      return {
        ratio: 60,
        force: true,
        isVisible: true
      }
    },
    methods: {
      close()
      {
        this.$emit('closeInteraction')

        this.open.play()
      }
    },
    created () {
    },
    mounted () {
      setTimeout( () => {
        this.open = new Howl({
          src: ['/assets/sounds/zoom.mp3']
        });
        this.open.play()
      }, 400)

      this.$parent.$emit('toggleRender', false)
      

      var CUR_ZI = 'zoom-in';
      var CUR_ZO = 'zoom-out';

      var imgContainer = this.$el
      
      var img = window.matchMedia("(orientation: portrait)").matches ? this.$el.querySelector('.mobile') : this.$el.querySelector('.desktop');
      var config = this.$el.dataset;

      if (img) {
        imgContainer.style.overflow = 'hidden';

        img.addEventListener('mousemove', function (e) {
          var x = e.pageX;
          var y = e.pageY;
          var w = img.offsetWidth;
          var h = img.offsetHeight;
          var originX = x / w * 100;
          var originY = y / h * 100;

          img.style.transformOrigin = originX + '% ' + originY + '%';
        });
        img.addEventListener('touchmove', function (e) {
          let touch = e.touches[0]
          var x = touch.pageX;
          var y = touch.pageY;
          var w = img.offsetWidth;
          var h = img.offsetHeight;
          var originX = x / w * 100;
          var originY = y / h * 100;

          img.style.transformOrigin = originX + '% ' + originY + '%';
        });

        // imgContainer.addEventListener('click', function () {
        //   var maxValue = parseInt(config.zoomMax || 1) + 1;
        //   var currValue = parseInt(config.zoomValue || 1);
        //   var nextValue = currValue + 1;

        //   if (nextValue > maxValue) {
        //     img.style.transform = 'scale(1)';
        //     img.style.cursor = CUR_ZI;
        //     imgContainer.setAttribute('data-zoom-value', '1');
        //   } else {
        //     img.style.transform = 'scale(' + nextValue + ')';
        //     imgContainer.setAttribute('data-zoom-value', nextValue);

        //     if (nextValue === maxValue) {
        //       img.style.cursor = CUR_ZO;
        //     }
        //   }
        // });
      }
    }
  }
</script>

<style lang="stylus">
.Zoom

  position fixed
  top 0%
  height 100%
  width 100%
  border-radius 0%
  left 0%

  .Close

    top 130px
    right 75px
    pointer-events auto

    @media $medium

      display none

  .Cta

    position relative
    z-index 2
    display none
    position fixed
    bottom 15px
    left 50%
    transform translateX(-50%) scale(0.8)
    pointer-events auto

    @media $medium

      display block

  &_wrapper

    position absolute
    top 0px
    left 0px
    width 100%
    background-color black
    height 100%

    &.scale-enter-active, &.scale-leave-active

      transition-duration 2.2s!important

    &.scale-enter, &.scale-leave-to
      opacity 0!important
      transform translate3d(0%,0%,0px) scale3d(0.05, 0.05, 1)!important

  &_mask

    position absolute
    top 0%
    height 100%
    width 100%
    left 0%

    &:after

      content ''
      position absolute
      top 0px
      height 100%
      width 100%
      left 0px
      background-image url('/assets/images/zoom.png')
      background-size cover
      transform-origin center center
      background-position center

      @media $small

        width 100vh
        height 100vw
        top 50%
        left 50%
        transform translate(-50%, -50%) rotate(90deg)

  &_background

    pointer-events auto
    top 0%
    min-height 100%
    width 100%
    left 0%
    object-fit cover
    transform scale(2)
    -webkit-touch-callout: none!important;
    -webkit-user-select:none!important;

    &.mobile

      display none
      width 120%
      left -10%

      @media (orientation: portrait)

        display block

    &.desktop

      display block

      @media (orientation: portrait)

        display none
</style>